export default {
    reg: {
      password:{
        value:/^[a-zA-Z0-9!" #$%&'()*+,-./:;<=>?@\[\\\]^_`{|}~]{8,20}$/,
        // value:/^(?![^a-zA-Z]+$)(?!\D+$)[a-zA-Z0-9]{8,20}$/,
        desc:"Support 8 to 20 upper and lower case, numbers and special characters"
      },
      username:{
        value:/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        desc:"Please enter the email format within 30 characters"
      },
      email:{
        value:/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        desc:"Please enter email format"
      },
      common:{
        value:/^[a-zA-Z]{1,50}$/,
        desc:"Within 50 English characters"
      },
      // APIGravity:{
      //   value:/^0\.[0-9]{1,4}$|^0{1}$|^1{1}$|^1\.[0]{1,4}$/,
      //   desc:"4 decimal places are supported between 0 and 1"
      // },
      APIGravity:{
        value:/^(\d|[1-9]\d|100)(\.\d{1,2})?$/,
        desc:"2 decimal places are supported between 0 and 100"
      },
      sulphur:{
        value:/^(\d|[1-9]\d|100)(\.\d{1,2})?$/,
        desc:"2 decimal places are supported between 0 and 100"
      },
      number:{
        value:/^\d*$/,
        desc:"Please enter number format"
      },
      telephone:{
        value:/^[0-9-]*$/,
        desc:"Please enter phone format"
      },
      postalCode:{
        value:/^[0-9-]*$/,
        desc:"Please enter postal code format"
      }

    }
}
